import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { queryClient } from "App";
import axiosInstance from "axiosConfig";
import { PACKET_ENUM, TOAST_TYPES_ENUM } from "enums";
import { Toast } from "shared";

export const useChangePacket = (
  options?: UseMutationOptions<any, Error, PACKET_ENUM>
) => {
  return useMutation({
    mutationKey: ["changePacket"],
    mutationFn: async (values: PACKET_ENUM) => {
      return axiosInstance
        .put(`users/package`, { package: values })
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: "Ładowanie...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "changePacket",
      });

      if (options && options.onMutate) {
        // @ts-ignore
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: "Zaktualizowano pakiet",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "changePacket",
      });
      queryClient.prefetchQuery({ queryKey: ["me"] });
      queryClient.invalidateQueries({ queryKey: ["customers"] });
      queryClient.invalidateQueries({ queryKey: ["subscriptions"] });
      queryClient.invalidateQueries({ queryKey: ["paymentMethods"] });
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },

    onError: (error, variables, context) => {
      Toast({
        message: "Błąd podczas aktualizacji pakietu",
        type: TOAST_TYPES_ENUM.ERROR,
        id: "changePacket",
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};
